import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { OpenDrawerEventPayload } from '@typesApp/AppEvent'
import { ROUTES } from '@constants/index'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { setAppVisibleAllowed, setReadonlyMode } from '@redux/slices/workflowSlice'
import { getDefaultView } from '@utils/defaultView'
import { setLocalBasePath } from '@utils/navigationUtil'
import { usePathBuilder } from './usePathBuilder'

type UseOpenDrawerReturn = {
  openDrawer: (payload?: OpenDrawerEventPayload) => void
}

export const useOpenDrawer = (): UseOpenDrawerReturn => {
  const dispatch = useDispatch()
  const buildPath = usePathBuilder()
  const navigate = useAppNavigate()

  const openDrawer = useCallback(
    (payload?: OpenDrawerEventPayload) => {
      setLocalBasePath()

      dispatch(setAppVisibleAllowed())
      if (payload?.viewOnly) {
        dispatch(setReadonlyMode())
      }

      navigate(
        buildPath(payload?.target ?? getDefaultView(ROUTES.START)),
        payload?.navigateState ? { state: payload?.navigateState } : undefined
      )

      if (typeof payload?.callback === 'function') {
        payload?.callback?.()
      }
    },
    [dispatch, buildPath, navigate]
  )

  return {
    openDrawer,
  }
}
